import { jsx as e } from "react/jsx-runtime";
import s from "../../../../elements/link-wrapper/link-wrapper.js";
import r from "./desktop-menu-modal-content.module.less.js";
const o = ({ links: t }) => /* @__PURE__ */ e("div", { className: r.wrapper, children: /* @__PURE__ */ e("div", { className: r.innerWrapper, children: /* @__PURE__ */ e("ul", { className: r.links, children: t?.map((a, l) => /* @__PURE__ */ e("li", { className: r.linkItem, children: /* @__PURE__ */ e(
  s,
  {
    url: a?.url,
    target: a?.target,
    className: `${r.link} body-l mb-0`,
    onPreNavigate: a?.onPreNavigate,
    children: a?.title
  }
) }, l)) }) }) });
export {
  o as default
};
